import { OrderJourneyContent } from '@sh24/ui-components'
import dynamic from 'next/dynamic'

const ReactJson = dynamic(() => import('react-json-view'), { ssr: false })

const ReactJsonWrapper = ({ src }) => (
  <ReactJson
    src={src}
    collapsed={1}
    name={false}
    enableClipboard
    displayDataTypes={false}
  />
)

const DebugPanel = ({ context }) => {
  const {
    journey,
    basket,
    errors,
    errorMessages,
    validationLabels,
    products,
    discountSettings,
    ...rest
  } = context

  delete rest.deliveryAddress_addressList
  delete rest.billingAddress_addressList

  const translations = {
    errorMessages,
    validationLabels,
  }

  return (
    <OrderJourneyContent>
      <details>
        <summary>Debug</summary>
        <details className="ml-md mt-md">
          <summary>Verification codes</summary>
          <ReactJsonWrapper src={{ phone: context.smsVerificationCode, email: context.emailVerificationCode }} />
        </details>

        <details className="ml-md mt-md">
          <summary>Basket</summary>
          <ReactJsonWrapper src={basket} />
        </details>

        <details className="ml-md mt-md">
          <summary>Errors</summary>
          <ReactJsonWrapper src={errors} />
        </details>

        <details className="ml-md mt-md">
          <summary>Journey</summary>
          <ReactJsonWrapper src={journey} />
        </details>

        <details className="ml-md mt-md">
          <summary>Products</summary>
          <ReactJsonWrapper src={products} />
        </details>

        <details className="ml-md mt-md">
          <summary>Discounts</summary>
          <ReactJsonWrapper src={discountSettings} />
        </details>

        <details className="ml-md mt-md">
          <summary>Translations</summary>
          <ReactJsonWrapper src={translations} />
        </details>

        <details className="ml-md mt-md">
          <summary>Remaining Context</summary>
          <ReactJsonWrapper src={rest} />
        </details>

        <details className="ml-md mt-md">
          <summary>Full Context</summary>
          <ReactJsonWrapper src={context} />
        </details>
      </details>
    </OrderJourneyContent>
  )
}

export default DebugPanel
